import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-events',
  template: `
    <div class="wrapperSub">
      <events-view *axLazyElement></events-view>
    </div>
  `,
  styleUrls: ['../../app.component.scss'],
})
export class EventsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
